import React from "react";

import "./Tooltip.sass";

export const Tooltip = ({ children, style, className, description }) => {
  const handleMouseEnter = (event) => {
    if (description) {
      const tooltip = document.createElement("div");

      tooltip.className = "custom-tooltip";
      tooltip.textContent = description;

      tooltip.style.top = `${event.clientY + 25}px`;
      tooltip.style.left = `${event.clientX - 40}px`;

      document.body.appendChild(tooltip);
    }
  };

  const handleMouseMove = (event) => {
    if (description) {
      const tooltip = document.querySelector(".custom-tooltip");

      if (tooltip) {
        if (!tooltip.style) {
          tooltip.style = {};
        }

        tooltip.style.top = `${event.clientY + 25}px`;
        tooltip.style.left = `${event.clientX - 40}px`;
      }
    }
  };

  const handleMouseLeave = () => {
    if (description) {
      const tooltip = document.querySelector(".custom-tooltip");

      if (tooltip) {
        tooltip.remove();
      }
    }
  };

  return (
    <div
      style={style}
      className={className}
      onMouseMove={handleMouseMove}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}
    </div>
  );
};
